import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: '/page2/',
  routes: [
    {
      path: '/test',
      component: resolve => require(['@/h5/test'], resolve),
    },
    //抽奖
    {
      path: '/lottery',
      component: resolve => require(['@/page/lottery'], resolve),
    },


    //江苏第二师范云合影
    {
      path: '/cloud_group_photo/jsdrsf',
      component: resolve => require(['@/page/cloud_group_photo'], resolve),
    },
    {
      path: '/cloud_group_photo/jsdrsf/my',
      component: resolve => require(['@/page/cloud_group_photo/my'], resolve),
    },
    {
      path: '/cloud_group_photo/jsdrsf/photo',
      component: resolve => require(['@/page/cloud_group_photo/photo'], resolve),
    },
    {
      path: '/cloud_group_photo/jsdrsf/edit_avatar',
      component: resolve => require(['@/page/cloud_group_photo/edit_avatar'], resolve),
    },
    {
      path: '/cloud_group_photo/jsdrsf/place_photo',
      component: resolve => require(['@/page/cloud_group_photo/place_photo'], resolve),
    },

    //厦门城市学院云合影   
    {
      path: '/cloud_group_photo/xmcsxy',
      component: resolve => require(['@/page/cloud_group_photo_xmcsxy'], resolve),
    },
    {
      path: '/cloud_group_photo/xmcsxy/my',
      component: resolve => require(['@/page/cloud_group_photo_xmcsxy/my'], resolve),
    },
    {
      path: '/cloud_group_photo/xmcsxy/photo',
      component: resolve => require(['@/page/cloud_group_photo_xmcsxy/photo'], resolve),
    },
    {
      path: '/cloud_group_photo/xmcsxy/edit_avatar',
      component: resolve => require(['@/page/cloud_group_photo_xmcsxy/edit_avatar'], resolve),
    },
    {
      path: '/cloud_group_photo/xmcsxy/place_photo',
      component: resolve => require(['@/page/cloud_group_photo_xmcsxy/place_photo'], resolve),
    },
    //新乡医学院云合影  
    {
      path: '/cloud_group_photo/xxyxy',
      component: resolve => require(['@/page/cloud_group_photo_xxyxy'], resolve),
    },
    {
      path: '/cloud_group_photo/xxyxy/my',
      component: resolve => require(['@/page/cloud_group_photo_xxyxy/my'], resolve),
    },
    {
      path: '/cloud_group_photo/xxyxy/photo',
      component: resolve => require(['@/page/cloud_group_photo_xxyxy/photo'], resolve),
    },
    {
      path: '/cloud_group_photo/xxyxy/edit_avatar',
      component: resolve => require(['@/page/cloud_group_photo_xxyxy/edit_avatar'], resolve),
    },
    {
      path: '/cloud_group_photo/xxyxy/place_photo',
      component: resolve => require(['@/page/cloud_group_photo_xxyxy/place_photo'], resolve),
    },
    // 成员积分
    {
      path: '/member_points/index',
      component: resolve => require(['@/page/member_points/index'], resolve),
    },
    {
      path: '/member_points/details',
      component: resolve => require(['@/page/member_points/details'], resolve),
    },
     {
      path: '/school_day',
      component: resolve => require(['@/page/school_day'], resolve),
    },
    //清缓存
    {
      path: '/clear',
      component: resolve => require(['@/page/clear'], resolve),
    },
    //两会两院排名
    {
      path: '/NPC_CPPCC',
      component: resolve => require(['@/page/NPC_CPPCC'], resolve),
    },
    {
      path: '/NPC_CPPCC/name_list',
      component: resolve => require(['@/page/NPC_CPPCC/name_list'], resolve),
    },
    {
      path: '/NPC_CPPCC/subscribe',
      component: resolve => require(['@/page/NPC_CPPCC/subscribe'], resolve),
    },
    {
      path: '/NPC_CPPCC/detail',
      component: resolve => require(['@/page/NPC_CPPCC/detail'], resolve),
    },
    //中国共产党第二十次全国代表大会排行榜
    {
      path: '/communist_party_ranking_20th',
      component: resolve => require(['@/page/communist_party_ranking_20th'], resolve),
    },
    {
      path: '/communist_party_ranking_20th/name_list',
      component: resolve => require(['@/page/communist_party_ranking_20th/name_list'], resolve),
    },
    {
      path: '/communist_party_ranking_20th/subscribe',
      component: resolve => require(['@/page/communist_party_ranking_20th/subscribe'], resolve),
    },
    {
      path: '/communist_party_ranking_20th/detail',
      component: resolve => require(['@/page/communist_party_ranking_20th/detail'], resolve),
    },
    //企业高管排行榜
    {
      path: '/senior_ranking/usho',
      component: resolve => require(['@/page/senior_ranking/index'], resolve),
    },
    {
      path: '/senior_ranking/detail/usho',
      component: resolve => require(['@/page/senior_ranking/detail'], resolve),
    },
    {
      path: '/talent/ranking',
      component: resolve => require(['@/page/talent/ranking'], resolve),
    },
    {
      path: '/talent/record',
      component: resolve => require(['@/page/talent/record'], resolve),
    },
    {
      path: '/alumni/circle',
      name: '校友圈',
      component: resolve => require(['@/page/alumni/circle'], resolve),
    },
    {
      path: '/alumni/pubDynamic',
      name: '发布动态',
      component: resolve => require(['@/page/alumni/pubDynamic'], resolve),
    },
    // 新乡医学院
    {
      path: '/xX_medical_college/home',
      name: '新乡医学院100周年',
      component: resolve => require(['@/page/xX_medical_college/home'], resolve),
    },
    {
      path: '/xX_medical_college/integral',
      name: '积分明细',
      component: resolve => require(['@/page/xX_medical_college/integral'], resolve),
    },
    {
      path: '/xx/photo_article_collection',
      name: '图文征集',
      component: resolve => require(['@/page/xX_medical_college/photo_article_collection'], resolve),
    },



    // h5部分
    {
      path: '/project/donation_thanks',
      name: '捐赠鸣谢',
      component: resolve => require(['@/h5/project/donation_thanks'], resolve),
    },
    {
      path: '/activity/detail',
      component: resolve => require(['@/h5/activity/detail'], resolve),
    },
    {
      path: '/article_view',
      name: '文章预览',
      component: resolve => require(['@/h5/article_view'], resolve),
    },
    {
      path: '/activity/evaluate',
      component: resolve => require(['@/h5/activity/evaluateList'], resolve),
    },
    {
      path: '/activity/comment',
      component: resolve => require(['@/h5/activity/commentList'], resolve),
    },
    {
      path: '/activity/group',
      component: resolve => require(['@/h5/activity/groupList'], resolve),
    },
    {
      path: '/activity/member',
      component: resolve => require(['@/h5/activity/memberList'], resolve),
    },
    {
      path: '/back_school/detail',
      name: '返校预约',
      component: resolve => require(['@/h5/back_school/detail'], resolve),
    },

    {
      path: '/back_school/list',
      name: '预约返校',
      component: resolve => require(['@/h5/back_school/list'], resolve),
    },

    {
      path: '/back_school/my',
      name: '我的返校',
      component: resolve => require(['@/h5/back_school/my'], resolve),

    },
    {
      path: '/back_school/signin',
      component: resolve => require(['@/h5/back_school/signin'], resolve),

    },
    {
      path: '/back_school/signin_fail',
      component: resolve => require(['@/h5/back_school/signin_fail'], resolve),
    },
    {
      path: '/back_school/signin_success',
      component: resolve => require(['@/h5/back_school/signin_success'], resolve),
    },
    //表单
    {
      path: '/form',
      name: '表单详情',
      component: resolve => require(['@/h5/form/index'], resolve),
    },
    {
      path: '/form/create',
      name: '新增表单',
      component: resolve => require(['@/h5/form/create'], resolve),
    },
    {
      path: '/form/formview',
      name: '发布填写表单',
      component: resolve => require(['@/h5/form/formview'], resolve),
    },
    {
      path: '/form/createSuccess',
      name: '新增表单',
      component: resolve => require(['@/h5/form/createSuccess'], resolve),
    },
    {
      path: '/form/submitSuccess',
      name: '新增表单',
      component: resolve => require(['@/h5/form/submitSuccess'], resolve),
    },
    {
      path: '/find_alumni/myfind_alumins',
      component: resolve => require(['@/h5/find_alumni/myfind_alumins'], resolve),
    },
    {
      path: '/find_alumni/find_myalumins',
      component: resolve => require(['@/h5/find_alumni/find_myalumins'], resolve),
    },
    {
      path: '/find_alumni/alumni_setting',
      component: resolve => require(['@/h5/find_alumni/alumni_setting'], resolve),
    },
    {
      path: '/find_alumni/setting_price',
      component: resolve => require(['@/h5/find_alumni/setting_price'], resolve),
    },
    {
      path: '/find_alumni/search_memeber',
      component: resolve => require(['@/h5/find_alumni/search_memeber'], resolve),
    },
    {
      path: '/find_alumni/agreement',
      component: resolve => require(['@/h5/find_alumni/agreement'], resolve),
    },
    {
      path: '/com_setting',
      component: resolve => require(['@/h5/find_alumni/com_setting'], resolve),
    },

    {
      path: '/all_find_alumni/myfind_alumins',
      component: resolve => require(['@/h5/all_find_alumni/myfind_alumins'], resolve),
    },
    {
      path: '/all_find_alumni/find_myalumins',
      component: resolve => require(['@/h5/all_find_alumni/find_myalumins'], resolve),
    },
    {
      path: '/all_find_alumni/alumni_setting',
      component: resolve => require(['@/h5/all_find_alumni/alumni_setting'], resolve),
    },
    {
      path: '/all_find_alumni/setting_price',
      component: resolve => require(['@/h5/all_find_alumni/setting_price'], resolve),
    },
    {
      path: '/all_find_alumni/search_memeber',
      component: resolve => require(['@/h5/all_find_alumni/search_memeber'], resolve),
    },
    {
      path: '/all_find_alumni/agreement',
      component: resolve => require(['@/h5/all_find_alumni/agreement'], resolve),
    },

    {
      path: '/create_community',
      component: resolve => require(['@/h5/create_community'], resolve),
    },
    {
      path: '/create_community_success',
      component: resolve => require(['@/h5/create_community_success'], resolve),
    },

    {
      path: '/form/administration',
      name: '管理表单',
      component: resolve => require(['@/h5/form/administration'], resolve),
    },
    {
      path: '/form/recordform',
      name: 'TA的表单',
      component: resolve => require(['@/h5/form/recordform'], resolve),
    },
    {
      path: '/form/statisticaldetails',
      name: '统计详情',
      component: resolve => require(['@/h5/form/statisticaldetails'], resolve),
    },
    {
      path: '/form/search',
      name: '表单搜索',
      component: resolve => require(['@/h5/form/search'], resolve),
    },


    {
      path: '/mutual/edit',
      name: '发布帖子',
      component: resolve => require(['@/h5/mutual/edit'], resolve),
    },
    {
      path: '/alumni_enterprise',
      name: '校友企业',
      component: resolve => require(['@/h5/alumni_enterprise'], resolve),
    },

    // 时光影像馆-学校
    {
      path: '/sgyx',
      component: resolve => require(['@/sgyx/main'], resolve),
      children: [
        {
          path: '/sgyx/index',
          component: resolve => require(['@/sgyx/index'], resolve),
        },
        {
          path: '/sgyx/college',
          component: resolve => require(['@/sgyx/college'], resolve),
        },
        {
          path: '/sgyx/scorerank',
          component: resolve => require(['@/sgyx/scorerank'], resolve),
        },
        {
          path: '/sgyx/class_list',
          component: resolve => require(['@/sgyx/classList'], resolve),
        },
        {
          path: '/sgyx/collegeClassList',
          component: resolve => require(['@/sgyx/collegeClassList'], resolve),
        },
        {
          path: '/sgyx/laboratory',
          component: resolve => require(['@/sgyx/laboratory'], resolve),
        },
        {
          path: '/sgyx/trends_news',
          component: resolve => require(['@/sgyx/trends_news'], resolve),
        },
        {
          path: '/sgyx/article_detail',
          component: resolve => require(['@/sgyx/article_detail'], resolve),
        },
        {
          path: '/sgyx/class',
          component: resolve => require(['@/sgyx/class'], resolve),
        },
        {
          path: '/sgyx/pubStory',
          component: resolve => require(['@/sgyx/pubStory'], resolve),
        },
        {
          path: '/sgyx/storyAboutMe',
          component: resolve => require(['@/sgyx/storyAboutMe'], resolve),
        },
        {
          path: '/sgyx/albums',
          component: resolve => require(['@/sgyx/album'], resolve),
        },
        {
          path: '/sgyx/integral',
          component: resolve => require(['@/sgyx/integral'], resolve),
        },
        {
          path: '/sgyx/imageStory',
          component: resolve => require(['@/sgyx/imageStory'], resolve),
        },
        {
          path: '/sgyx/photos',
          component: resolve => require(['@/sgyx/photos'], resolve),
        },
        {
          path: '/sgyx/member_detail',
          component: resolve => require(['@/sgyx/member_detail'], resolve),
        },
        {
          path: '/sgyx/homeImageStory',
          component: resolve => require(['@/sgyx/homeImageStory'], resolve),
        },

      ]
    },

    // 时光影像馆-院系
    {
      path: '/sgyx-college',
      component: resolve => require(['@/sgyx-college/main'], resolve),
      children: [
        {
          path: '/sgyx-college/index',
          component: resolve => require(['@/sgyx-college/index'], resolve),
        },
        {
          path: '/sgyx-college/college',
          component: resolve => require(['@/sgyx-college/college'], resolve),
        },
        {
          path: '/sgyx-college/scorerank',
          component: resolve => require(['@/sgyx-college/scorerank'], resolve),
        },
        {
          path: '/sgyx-college/class_list',
          component: resolve => require(['@/sgyx-college/classList'], resolve),
        },
        {
          path: '/sgyx-college/collegeClassList',
          component: resolve => require(['@/sgyx-college/collegeClassList'], resolve),
        },
        {
          path: '/sgyx-college/laboratory',
          component: resolve => require(['@/sgyx-college/laboratory'], resolve),
        },
        {
          path: '/sgyx-college/trends_news',
          component: resolve => require(['@/sgyx-college/trends_news'], resolve),
        },
        {
          path: '/sgyx-college/article_detail',
          component: resolve => require(['@/sgyx-college/article_detail'], resolve),
        },
        {
          path: '/sgyx-college/class',
          component: resolve => require(['@/sgyx-college/class'], resolve),
        },
        {
          path: '/sgyx-college/pubStory',
          component: resolve => require(['@/sgyx-college/pubStory'], resolve),
        },
        {
          path: '/sgyx-college/storyAboutMe',
          component: resolve => require(['@/sgyx-college/storyAboutMe'], resolve),
        },
        {
          path: '/sgyx-college/albums',
          component: resolve => require(['@/sgyx-college/album'], resolve),
        },
        {
          path: '/sgyx-college/integral',
          component: resolve => require(['@/sgyx-college/integral'], resolve),
        },

        {
          path: '/sgyx-college/imageStory',
          component: resolve => require(['@/sgyx-college/imageStory'], resolve),
        },
        {
          path: '/sgyx-college/homeImageStory',
          component: resolve => require(['@/sgyx-college/homeImageStory'], resolve),
        },
        {
          path: '/sgyx-college/photos',
          component: resolve => require(['@/sgyx-college/photos'], resolve),
        },
        {
          path: '/sgyx-college/member_detail',
          component: resolve => require(['@/sgyx-college/member_detail'], resolve),
        },
        {
          path: '/sgyx-college/enteringSchoolYear',
          component: resolve => require(['@/sgyx-college/enteringSchoolYear'], resolve),
        },
      ]
    },
    {
      path: '/cooperate/login',
      name: '我要合作',
      component: resolve => require(['@/h5/cooperate/login'], resolve),
    },
    {
      path: '/cooperate',
      name: '我要合作',
      component: resolve => require(['@/h5/cooperate/index'], resolve),
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js